"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import Clock01Icon from "@hugeicons/core-free-icons/Clock01Icon";
import FlashIcon from "@hugeicons/core-free-icons/FlashIcon";
import UserAdd01Icon from "@hugeicons/core-free-icons/UserAdd01Icon";
import MouseLeftClick01Icon from "@hugeicons/core-free-icons/MouseLeftClick01Icon";
import ChartIncreaseIcon from "@hugeicons/core-free-icons/ChartIncreaseIcon";
import RepeatIcon from "@hugeicons/core-free-icons/RepeatIcon";
import UserGroupIcon from "@hugeicons/core-free-icons/UserGroupIcon";
import Moon01Icon from "@hugeicons/core-free-icons/Moon01Icon";

const BENEFIT_PILLS = [
  { label: "Save 10+ hrs/week", icon: Clock01Icon, bg: "bg-[#DCFCE7]", text: "text-[#166534]", row: 0 },
  { label: "Reply in seconds", icon: FlashIcon, bg: "bg-[#DBEAFE]", text: "text-[#1E40AF]", row: 0 },
  { label: "Capture more leads", icon: UserAdd01Icon, bg: "bg-[#F3E8FF]", text: "text-[#6B21A8]", row: 0 },
  { label: "Drive more clicks", icon: MouseLeftClick01Icon, bg: "bg-[#FFEDD5]", text: "text-[#9A3412]", row: 0 },
  { label: "Boost engagement", icon: ChartIncreaseIcon, bg: "bg-[#FCE7F3]", text: "text-[#9D174D]", row: 1 },
  { label: "Automate repetitive work", icon: RepeatIcon, bg: "bg-[#E0E7FF]", text: "text-[#3730A3]", row: 1 },
  { label: "Grow Followers", icon: UserGroupIcon, bg: "bg-[#CCFBF1]", text: "text-[#115E59]", row: 1 },
  { label: "Works while you sleep", icon: Moon01Icon, bg: "bg-[#FEF9C3]", text: "text-[#854D0E]", row: 1 },
] as const;

export default function CreatorBenefits() {
  const topRow = BENEFIT_PILLS.filter((p) => p.row === 0);
  const bottomRow = BENEFIT_PILLS.filter((p) => p.row === 1);

  return (
    <section
      className="w-full overflow-hidden bg-[#FAFAFA] dark:bg-[#0A0A0B]"
    >
      <div className="mx-auto w-full max-w-5xl container-padding py-24 sm:py-32">
        {/* Heading */}
        <h2
          data-cb-heading
          className="mx-auto max-w-3xl text-center text-3xl font-extrabold leading-[1.12] tracking-tight text-foreground sm:text-5xl lg:text-6xl"
        >
          Top creators{" "}
          <span className="bg-primary-gradient bg-clip-text text-transparent">
            don&apos;t reply manually
          </span>{" "}
          anymore.
        </h2>

        {/* Pills — two rows, centered, bigger */}
        <div className="mt-10 flex flex-col items-center gap-3 sm:mt-14 sm:gap-4">
          {/* Top row */}
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-3.5">
            {topRow.map((pill, index) => (
              <span
                key={pill.label}
                data-cb-pill
                className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold shadow-sm sm:gap-2.5 sm:px-6 sm:py-3 sm:text-base ${index % 2 === 0 ? "animate-float-soft" : "animate-float-soft-delay"} ${pill.bg} ${pill.text}`}
              >
                <HugeiconsIcon icon={pill.icon} size={18} color="currentColor" className="sm:hidden" />
                <HugeiconsIcon icon={pill.icon} size={20} color="currentColor" className="hidden sm:block" />
                {pill.label}
              </span>
            ))}
          </div>
          {/* Bottom row */}
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-3.5">
            {bottomRow.map((pill, index) => (
              <span
                key={pill.label}
                data-cb-pill
                className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold shadow-sm sm:gap-2.5 sm:px-6 sm:py-3 sm:text-base ${index % 2 === 0 ? "animate-float-soft-delay-2" : "animate-float-soft-delay"} ${pill.bg} ${pill.text}`}
              >
                <HugeiconsIcon icon={pill.icon} size={18} color="currentColor" className="sm:hidden" />
                <HugeiconsIcon icon={pill.icon} size={20} color="currentColor" className="hidden sm:block" />
                {pill.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
